<template>
  <div id="userinfocommit_homeandwork-wrap">
    <div class="header">车家</div>
    <div class="container">
      <div class="addressInfo item_part">
        <div class="item_title">
          <div class="icon_img"><img src="../assets/image/Photo/chejia_corner_icon.png"/></div>
          <div class="title">住址信息</div>
        </div>
        <div class="input_item">
          <div class="caption"><p>居住省市</p></div>
          <input type="text" v-model="liveCityName" readonly="readonly" @focus="checkFocus" @blur="pageDown" @click="livingInformationBoxShow"/>
          <div>
            <img src="../assets/image/Homepage/chejia_5.png"/>
          </div>
        </div>
        <div class="input_item">
          <div class="caption"><p>居住地址</p></div>
          <input type="text" v-model="liveAddress"/>
        </div>
      </div>
      <div class="workInfo item_part">
        <div class="item_title">
          <div class="icon_img"><img src="../assets/image/Photo/chejia_corner_icon.png"/></div>
          <div class="title">工作信息</div>
        </div>
        <div class="input_item">
          <div class="caption"><p>单位名称</p></div>
          <input type="text" v-model="companyName" @focus="checkFocus" @blur="pageDown"/>
        </div>
        <div class="input_item">
          <div class="caption"><p>单位地址</p></div>
          <input type="text" v-model="companyAddress" @focus="checkFocus" @blur="pageDown"/>
        </div>
      </div>
      <div class="sure_button">
        <button @click="submitCustomerData">提交</button>
      </div>

      <!-- 省份弹窗 -->
      <div v-show="provinceBoxShowFalg" class="eventBox" id="provinceBox">
        <div class="box_part">
          <div class="initial_index_part" v-show="false">
            <ul>
              <li v-for="(item,index) in initialsList" v-bind:key="index"><a>{{item}}</a></li>
            </ul>
          </div>
          <div class = "livingInformation_section" v-for="(value,index) in initialsList" v-bind:key="index">
            <div class = "livingInformation_part">
              <div class = "caption" :id="value"><p>{{value}}</p></div>
              <div class = "livingInformation_cell"  v-for="(item,index) in provincesList" v-bind:key="index" v-if="item.backupCol1 == value" @click="getCity(item.itemCd, item.itemContent)">{{item.itemContent}}</div>
            </div>
            <!--<div class="livingInformation_cell" title="Zack"  v-for="(item,index) in provincesList" v-bind:key="index" v-if="item.backupCol1 == value" :title="item.itemContent" @click.native="getCity(item.itemCd)"></div>-->
          </div>
        </div>
      </div>
      <!-- 城市弹窗 -->
      <div v-show="cityBoxShowFalg" class="eventBox" id="cityBox">
        <div class="box_part">
          <div class = "livingInformation_section">
            <div class = "livingInformation_part">
              <!--<div>{{citysList}}</div>-->
              <div class = "livingInformation_cell"  v-for="(value,key,index) in citiesList" v-bind:key="index" :data-cityCode="key" @click="informationShowInPage(value, key)">{{value}}</div>
            </div>
            <!--<div class="livingInformation_cell" title="Zack"  v-for="(item,index) in provincesList" v-bind:key="index" v-if="item.backupCol1 == value" :title="item.itemContent" @click.native="getCity(item.itemCd)"></div>-->
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
  import { Toast } from 'mint-ui'
  import { Indicator } from 'mint-ui'
  import { IndexList, IndexSection } from 'mint-ui'
  import common from '../utils/common'
  import Vue from 'vue'
  import qs from 'qs';
  Vue.component(IndexList.name, IndexList);
  Vue.component(IndexSection.name, IndexSection);

  export default {
    name: "",
    data() {
      return {
        inFocus: false,
        idc: null,
        mobile: null,
        liveCityName: '',
        liveAddress: '',
        companyName: '',
        companyAddress: '',
        provinceBoxShowFalg: false,
        cityBoxShowFalg: false,
        provincesList: null,
        citiesList: null,
        provinceVal: null,
        provinceCode: null,
        cityVal: null,
        cityCode: null,
        initialsList: []
      }
    },
    computed: {
      mobilePhone(){
        return sessionStorage.getItem("mobilePhone")
      },
      userId(){
        return sessionStorage.getItem("userId")
      }
    },
    mounted(){
      window.scrollTo(0, 0)
      const that = this
      that.$nextTick(function () {
        that.idc = that.userId
        that.mobile = that.mobilePhone;
        if(common.trimAll(that.mobile) == null){
          that.$router.push({
            path: '/',
            name: "Homepage",
            params: ''
          })
        }
        const initialsArr = []
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        that.$axios.get('/marketing/getprovince',  {
        }).then(function (res) {
          Indicator.close()
          that.provincesList = res.data.data.proMap
          for(let key in that.provincesList){
            if(that.initialsList.indexOf(that.provincesList[key].backupCol1) == -1){
              that.initialsList.push(that.provincesList[key].backupCol1)
            }
          }
          that.initialsList.sort()
        }).catch(function (error) {
          Indicator.close()
          Toast({
            message: error.data.msg,
            className: 'longMsgStyle'
          })
          return
        })
      })
    },
    methods: {
      checkFocus(){
        this.inFocus = true
      },
      pageDown(){
        this.inFocus = false
        setTimeout(function () {
          if(!this.inFocus){
            // 当input 失焦时,滚动一下页面就可以使页面恢复正常
            const timer = setInterval(() => {
              let currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
              const speed=1;//页面滚动距离
              currentPosition-=speed;
              window.scrollTo(0, currentPosition)
              clearInterval(timer);
            }, 1)
          }
        },200)
      },
      submitCustomerData(){
        const that = this
        const router = that.$router;
        const obj = {}
        obj.provinceId = that.provinceCode,
        obj.province4display = that.provinceVal,
        obj.cityId = that.cityCode,
        obj.city4display = that.cityVal,
        obj.address = common.trimAll(that.liveAddress),
        obj.workunitName = common.trimAll(that.companyName),
        obj.workAddress = common.trimAll(that.companyAddress)
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        });
        let data = { "obj": JSON.stringify(obj),
            "crmIdc": that.idc,
            "mobile": that.mobile}
        that.$axios.post('/marketing/commit',  qs.stringify(data)).then(function (res) {
          Indicator.close();
          sessionStorage.setItem("infoType", "isNotSku")
          router.push({
            path: '/successful',
            name: "Successful"
          })
        }).catch(function (error) {
          Indicator.close();
          Toast({
            message: error.data.msg,
            className: 'longMsgStyle'
          })
          return
        })
      },
      livingInformationBoxShow(){
        this.provinceBoxShowFalg = !this.provinceBoxShowFalg
      },
      getCity(provinceCode, provinceVal){
        this.cityBoxShowFalg = true
        const that = this
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        let data = {"num": '0', "strnum": provinceCode}
        that.$axios.post('/marketing/getCity',  qs.stringify(data)).then(function (res) {
          Indicator.close();
          that.provinceVal = provinceVal
          that.provinceCode = provinceCode
          that.citiesList = res.data.data
        }).catch(function (error) {
          Indicator.close();
          Toast({
            message: error.data.msg,
            className: 'longMsgStyle'
          })
          return
        })
      },
      informationShowInPage(val, key){
        this.cityVal = val
        this.cityCode = key
        this.provinceBoxShowFalg = false
        this.cityBoxShowFalg = false
        this.liveCityName = this.provinceVal + ' - ' + val
      }
    }
  }
</script>

<style scoped>

  .longMsgStyle{
    margin: 0 auto;
    width: 60%;
    left: 0!important;
    right: 0!important;
    transform: translate(-0%, -50%)!important;
  }
  #userinfocommit_homeandwork-wrap * {
    background-color: #fff;
  }

  #userinfocommit_homeandwork-wrap {
    width: 100vw;
  }

  #userinfocommit_homeandwork-wrap > .header {
    width: 100%;
    height: 0.98rem;
    line-height: 0.98rem;
    background-color: #fff;
    color: #222;
    font-size: 0.36rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    text-align: center;
  }

  #userinfocommit_homeandwork-wrap > .container {
    width: 100%;
  }

  #userinfocommit_homeandwork-wrap > .container > .item_part {
    position: relative;
    margin: 0 auto;
    width: 6.69rem;
    height: 3.32rem;
    background-color: #ffffff;
    box-shadow: 1.3px 8.9px 34.8px 14.2px rgba(71, 69, 250, 0.04);
    border-radius: 0.2rem;
    overflow: hidden;
  }

  #userinfocommit_homeandwork-wrap > .container > .workInfo {
    margin-top: 0.32rem;
  }
  #userinfocommit_homeandwork-wrap > .container > .item_part > .item_title > .icon_img {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.58rem;
    font-size: 0;
  }

 .container > .item_part > .item_title > .icon_img img {
    width: 100%;
  }

  .item_part > .item_title > .title {
    margin-top: 0.22rem;
    width: 100%;
    font-size: 0.30rem;
    font-weight: bold;
    font-stretch: normal;
    line-height: 0.30rem;
    color: #222222;
    text-align: center;
  }

  .container > .item_part > .input_item {
    position: relative;
    font-size: 0.26rem;
    margin-left: 0.42rem;
    margin-right: 0.42rem;
    height: 0.98rem;
    flex-flow: row nowrap;
    display: flex;
    border-bottom: solid 0.02rem #d7d7d7;
    align-items: center;
    overflow: hidden;
  }
  .container > .item_part > .input_item:nth-child(2) {
    margin-top: 0.21rem;
  }
  .container > .item_part > .input_item:nth-child(3) {
    margin-top: 0.04rem;
  }
   .container > .item_part > .input_item > .caption{
    width: 1.48rem;
    height: 0.98rem;
    position: absolute;
    top: 0;
    left: 0;
  }
 .container > .item_part > .input_item > .caption > p {
    margin: 0;
    padding: 0;
    line-height: 0.96rem;
    font-size: 0.26rem;
    font-weight: normal;
    font-stretch: normal;
    color: #222222;
  }
  .container > .item_part > .input_item input {
    width: 100%;
    padding-left: 1.78rem;
    height: 0.98rem;
    line-height: 0.36rem;
    border-width: 0;
    outline: none;
    box-shadow: none;
  }
  .container > .item_part > .input_item > div > img {
    position: absolute;
    top:43%;
    right: 0.29rem;
    width: 0.19rem;
    height: 0.11rem;
    font-size: 0;
  }
  #userinfocommit_homeandwork-wrap > .container > .addressInfo > .addressInfo_address_detail input {
    margin-left: 0.25rem;
  }


  #userinfocommit_homeandwork-wrap > .container > .sure_button {
    margin-top: 2.48rem;
    width: 100%;
    height: 1rem;
  }

  #userinfocommit_homeandwork-wrap > .container > .sure_button button {
    padding: 0;
    margin: 0;
    display: block;
    margin: 0 auto;
    width: 5.83rem;
    height: 1rem;
    font-size: 0.28rem;
    font-weight: normal;
    font-stretch: normal;
    color: #fff;
    border-width: 0;
    outline: none;
    background-image: linear-gradient(-90deg,
    #2694ff 0%,
    #42da94 100%),
    linear-gradient(
      #4080ee,
      #4080ee);
    background-blend-mode: normal,
    normal;
    border-radius: 0.12rem;
  }
  /*.mask_layer{*/
    /*position: fixed;*/
    /*top: 0;*/
    /*left: 0;*/
    /*right: 0;*/
    /*bottom: 0;*/
    /*background-color: #222!important;*/
    /*opacity: .3;*/
    /*z-index: 9;*/
  /*}*/
  .eventBox{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    z-index: 11;
  }
  .box_part{

    position: relative;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
  }
  .initial_index_part {
    border-left: 0.02rem solid #f4f4f4;
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 11;
  }
  .initial_index_part > ul{
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
  }
  .initial_index_part > ul > li{
    font-size: 0.18rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .initial_index_part > ul > li > a{
    display: block;
    padding: 0;
    margin: 0;
    padding: 0.04rem 0.06rem;
    width: 100%;
    height: 100%;
    text-decoration: none;
  }
  .initial_index_part > ul > li >a:link    {color:#222;}
  .initial_index_part > ul > li >a:visited {color:#222;}
  .initial_index_part > ul > li >a:hover   {color:#222;}
  .initial_index_part > ul > li >a:active  {color:#222;}
  .box_part p{
    margin: 0;
    padding: 0;
  }
  .livingInformation_section > .livingInformation_part{
  }
  .livingInformation_part > .caption{
    padding: 0.1rem 0.25rem;
    font-size: 0.36rem;
    color: #fff;
    background-color: #999!important;
  }
  .livingInformation_part > .caption > p{
    background-color: #999!important;
  }
  .livingInformation_part > .livingInformation_cell{
    border-bottom: 0.04rem solid #f4f4f4;
    padding: 0.25rem;
    font-size: 0.36rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserInfoCommit_HomeAndWork.vue